var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMetabotCloud96X96 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  viewBox: "0 0 96 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2220_3781)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_2220_3781",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 96,
  height: 96
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M96 0H0V96H96V0Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_2220_3781)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96Z",
  fill: "#74BCFC",
  fillOpacity: 0.21
}), /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 31,
  width: 48,
  height: 34,
  rx: 4,
  fill: "#EEF6FD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 35.0005C24 32.7913 25.7909 31.0005 28 31.0005H68C70.2091 31.0005 72 32.7913 72 35.0005V61.0005C72 63.2096 70.2091 65.0005 68 65.0005H28C25.7909 65.0005 24 63.2096 24 61.0005V35.0005Z",
  fill: "#0572D2",
  fillOpacity: 0.07
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.375 35.0005C71.375 33.1365 69.864 31.6255 68 31.6255H28C26.136 31.6255 24.625 33.1365 24.625 35.0005V61.0005C24.625 62.8644 26.136 64.3755 28 64.3755H68C69.864 64.3755 71.375 62.8644 71.375 61.0005V35.0005ZM72.625 61.0005C72.625 63.5548 70.5543 65.6255 68 65.6255H28C25.4457 65.6255 23.375 63.5548 23.375 61.0005V35.0005C23.375 32.4461 25.4457 30.3755 28 30.3755H68C70.5543 30.3755 72.625 32.4461 72.625 35.0005V61.0005Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.5 38.0005C29.5 37.172 30.1716 36.5005 31 36.5005H65C65.8284 36.5005 66.5 37.172 66.5 38.0005V55.0005C66.5 55.8289 65.8284 56.5005 65 56.5005H31C30.1716 56.5005 29.5 55.8289 29.5 55.0005V38.0005Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.875 38.0005C65.875 37.5172 65.4832 37.1255 65 37.1255H31C30.5168 37.1255 30.125 37.5172 30.125 38.0005V55.0005C30.125 55.4837 30.5168 55.8755 31 55.8755H65C65.4832 55.8755 65.875 55.4837 65.875 55.0005V38.0005ZM67.125 55.0005C67.125 56.1741 66.1736 57.1255 65 57.1255H31C29.8264 57.1255 28.875 56.1741 28.875 55.0005V38.0005C28.875 36.8269 29.8264 35.8755 31 35.8755H65C66.1736 35.8755 67.125 36.8269 67.125 38.0005V55.0005Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.536 60.7143C61.5358 60.458 61.3275 60.2504 61.0712 60.2504C60.8151 60.2506 60.6076 60.4582 60.6074 60.7143C60.6074 60.9705 60.815 61.1789 61.0712 61.1791V62.429L60.8964 62.4202C60.032 62.3325 59.3574 61.6019 59.3574 60.7143C59.3576 59.7679 60.1248 59.0007 61.0712 59.0005C62.0178 59.0005 62.7858 59.7677 62.786 60.7143L62.7772 60.89C62.6894 61.7544 61.9588 62.429 61.0712 62.429V61.1791C61.3276 61.1791 61.536 60.9707 61.536 60.7143Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.036 60.7143C66.0358 60.458 65.8275 60.2504 65.5712 60.2504C65.3151 60.2506 65.1076 60.4582 65.1074 60.7143C65.1074 60.9705 65.315 61.1789 65.5712 61.1791V62.429L65.3964 62.4202C64.532 62.3325 63.8574 61.6019 63.8574 60.7143C63.8576 59.7679 64.6248 59.0007 65.5712 59.0005C66.5178 59.0005 67.2858 59.7677 67.286 60.7143L67.2772 60.89C67.1894 61.7544 66.4588 62.429 65.5712 62.429V61.1791C65.8276 61.1791 66.036 60.9707 66.036 60.7143Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41 45C41.8284 45 42.5 44.3284 42.5 43.5C42.5 42.6716 41.8284 42 41 42C40.1716 42 39.5 42.6716 39.5 43.5C39.5 44.3284 40.1716 45 41 45Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55 45C55.8284 45 56.5 44.3284 56.5 43.5C56.5 42.6716 55.8284 42 55 42C54.1716 42 53.5 42.6716 53.5 43.5C53.5 44.3284 54.1716 45 55 45Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.375 47.5C46.375 48.0967 46.5718 48.4831 46.833 48.7246C47.1025 48.9735 47.5027 49.125 48 49.125C48.4973 49.125 48.8975 48.9735 49.167 48.7246C49.4282 48.4831 49.625 48.0967 49.625 47.5H50.875C50.875 48.3943 50.5676 49.1328 50.0146 49.6436C49.4698 50.1466 48.7452 50.375 48 50.375C47.2548 50.375 46.5302 50.1466 45.9854 49.6436C45.4324 49.1328 45.125 48.3943 45.125 47.5H46.375Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.625 51V53H15.375V51H16.625Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 53.375H15V54.625H13V53.375Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.625 55V57H15.375V55H16.625Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 53.375H19V54.625H17V53.375Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.625 75V77H42.375V75H43.625Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 77.375H42V78.625H40V77.375Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.625 79V81H42.375V79H43.625Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44 77.375H46V78.625H44V77.375Z",
  fill: "#509EE3"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.7637 61.0103C24.4491 61.1925 21.8203 63.8045 21.8203 67.0001C21.8203 70.3137 24.6471 73 28.1342 73H42.8665C46.3535 73 49.1803 70.3137 49.1803 67.0001C49.1803 63.8045 46.5515 61.1925 43.2369 61.0103C42.5099 57.5818 39.3223 55 35.5003 55C31.6782 55 28.4907 57.5818 27.7637 61.0103Z",
  fill: "#0572D2",
  fillOpacity: 0.15
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.5 52.625C36.0423 52.625 38.9623 55.0152 39.625 58.1396L39.7246 58.6084L40.2021 58.6348C43.2153 58.8004 45.5556 61.1654 45.5557 64C45.5557 66.9388 43.0385 69.375 39.8662 69.375H25.1338C21.9617 69.3748 19.4453 66.9387 19.4453 64C19.4454 61.1655 21.7848 58.8005 24.7979 58.6348L25.2754 58.6084L25.375 58.1396C26.0377 55.0152 28.9577 52.6251 32.5 52.625Z",
  fill: "white",
  stroke: "#509EE3",
  strokeWidth: 1.25
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2220_3781"
}, /*#__PURE__*/React.createElement("rect", {
  width: 96,
  height: 96,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMetabotCloud96X96);
export default ForwardRef;